var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header',{attrs:{"title":_vm.$t('examsFor', { name: _vm.name })}}),_c('v-progress-linear',{attrs:{"indeterminate":"","active":_vm.loading}}),_c('v-container',[_c('exam-list-card',{attrs:{"exams":_vm.exams,"invitation-key":_vm.invitationKey}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }